<template lang="pug">
el-form-item(label="仓库:"  :rules="[ { required: true } ]")
  el-autocomplete.w-300(placeholder="请输入仓库" v-model="warehouseName"
    @select="handleSelect" :fetch-suggestions="getWarehosesList" @blur="warehosesBlur")
    template(slot-scope="{ item }")
      span {{item.nameAbbr}}

</template>

<script>
export default {
  name: 'goodsCreate',
  data() {
    return {
      warehouseName: ''
    }
  },

  mounted() {
    this.warehouseName = this.$parent.$parent.goodsData.warehouseName || ''
  },
  methods: {
    /** 选择仓库 */
    handleSelect(item) {
      this.warehouseName = item.nameAbbr
      this.$parent.$parent.goodsData.warehouseName = item.name
      this.$parent.$parent.goodsData.warehouseId = item.id
    },
    /** 查询仓库失去焦点 */
    warehosesBlur() {
      if (!this.$parent.$parent.goodsData.warehouseId) {
        this.warehouseName = ''
        this.$parent.$parent.goodsData.warehouseName = ''
      }
    },
    /** 仓库模糊查询 */
    async getWarehosesList(name, cb) {
      let searchList = []
      if (name) {
        if (this.warehouseName !== name) {
          this.$parent.$parent.goodsData.warehouseId = ''
        }
        try {
          const result = await this.$post(
            'wh.pageQueryWarehoses',
            {
              warehoseQuery: {
                name,
                pageNo: 1,
                pageSize: 1000
              }
            },
            { notNeedLoading: true }
          )
          if (result.success && result.data[0]) {
            searchList = result.data[0].warehoses || [{ nameAbbr: '暂无数据' }]
          } else {
            searchList = [{ nameAbbr: '暂无数据' }]
          }
          cb(searchList)
        } catch (err) {
          console.log(err)
        }
      } else {
        cb([{ nameAbbr: '暂无数据' }])
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.w-185
  width 185px
</style>
